<template>
<div class="title1   mt-12">

  <div v-html="msg"></div>

</div>
</template>

<script>
import { EventBus } from "@/services/eventBus";
export default {
  data(){
    return {
       msgType: this.$route.params.id
    }
  },
  computed:{
    msg(){
      EventBus.$emit('flagChanged', false);
      if( this.msgType == 1 ){
        return "<p>Great choice!</p><p>An Insurance Representative will call you to discuss your quote and review your insurance needs.</p>";
      }
      if( this.msgType == 2 ){
        return "<p>Thank you for lettings us know.</p><p>An Insurance Representative will call you to discuss your quote and review your insurance needs.</p><p>Confirmation you are waiving the offer of insurance will be sent to your email.</p>";
      }
      if( this.msgType == 3){
        return "<p>Thank you for letting us know.</p><p>Confirmation you are waiving the offer of insurance will be sent to your email.</p>";
      }
      return "";
    }
  }
}
</script>

<style scoped>


</style>